import {DataFetcher} from '@aboutyou/data-fetcher';
import React from 'react';
import {useBASPlacementSection} from '../useGetProductBulkSection';
import {BASPlacementProps, BASPlacementView} from './BASPlacementView';

export const BASPlacement: React.FC<BASPlacementProps> = props => {
  return (
    <DataFetcher
      request={useBASPlacementSection()}
      Error={() => null}
      Loading={undefined}
      View={BASPlacementView}
      viewProps={props}
    />
  );
};
